exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*!\n * Developed for G.J. Gardner Homes by Softeq Development Corporation\n * http://www.softeq.com\n */:host{display:block;max-width:90vw;max-height:90vh}::ng-deep .image-viewer-overlay .mat-dialog-container{max-width:90vw;max-height:90vh}img{max-width:100%;max-height:calc(90vh - 60px)}", ""]);

// exports
